import ExpressionList from 'components/productManager/ExpressionList';

const ParameterExpressions = ({ modelKey, paramKey, parameter, deleteExpression, onExpressionChange }: any) => {
  if (!parameter[modelKey]?.expressionList) {
    return null;
  }

  const { expressions, expressionList } = parameter[modelKey];

  const newExpressionList = !expressionList ? Object.keys(expressions) : expressionList;

  return (
    <ExpressionList
      list={newExpressionList}
      values={parameter[modelKey].expressions}
      onExpressionChange={onExpressionChange}
      deleteExpression={deleteExpression}
      paramKey={paramKey}
      pkey={modelKey}
    />
  );
};

export default ParameterExpressions;
